import React, { useState } from "react";
import { db } from "../firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { toast } from "react-toastify";
import {
  Container,
  Typography,
  TextField,
  Button,
  Paper
} from "@mui/material";

const OrgRegistration = () => {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name.trim()) {
      toast.error("Organization name is required");
      return;
    }

    setLoading(true);
    try {
      await addDoc(collection(db, "organizations"), {
        name: name.trim(),
        description: description.trim(),
        createdAt: serverTimestamp(),
      });

      toast.success("Organization registered successfully!");
      setName("");
      setDescription("");
    } catch (error) {
      console.error("Error adding organization:", error);
      toast.error("Failed to register organization");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 4 }}>
      <Typography variant="h5" gutterBottom>
        Register Organization
      </Typography>

      <Paper elevation={3} sx={{ p: 4, mt: 2 }}>
        <form onSubmit={handleSubmit}>
          <TextField
            label="Organization Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            fullWidth
            required
            sx={{ mb: 3 }}
          />

          <TextField
            label="Description (optional)"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            multiline
            rows={3}
            fullWidth
            sx={{ mb: 3 }}
          />

          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            disabled={loading}
          >
            {loading ? "Registering..." : "Register Organization"}
          </Button>
        </form>
      </Paper>
    </Container>
  );
};

export default OrgRegistration;
